import {
  makeStyles,
  Paper,
  Theme,
  createStyles,
  Typography,
} from '@material-ui/core';
import { Helmet } from 'react-helmet';
import Header from '../../components/Header/Header';
import { APP_TITLE } from '../../utils/constants';
import { GetString } from '../../components/StringResourceManager';
import ProductsContainer from '../../components/ProductsManagement/ProductsContainer';
import { useDispatch, useSelector } from 'react-redux';
import { ApplicationState } from '../../store';
import React, { useEffect } from 'react';
import {
  LocaleInterface,
  locales,
} from '../../components/AlertsGrid/GridLocale';
import { Dispatch } from 'redux';
import {
  getAssetStoreList,
  getDivisionList,
  getLaneNumbers,
  getNodeTypeList,
  getNodeGroups,
} from '../../store/Assets/AssetsActions';
import { getNodeVersionPropertyValues } from '../../store/Versions/VersionsActions';
import { formatDateToLocaleDateString } from '../../utils/utils';
import ProductsHealthGrid from '../../components/ProductsManagement/ProductsHealthGrid';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'flex-start',
      '& > *': {
        margin: theme.spacing(2),
      },
    },
    paperGrid: {
      marginTop: theme.spacing(7),
      display: 'flex',
      flexDirection: 'column',
    },
    dateTime: {
      textAlign: 'center',
      color: '#23496B',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      height: 35,
    },
  }),
);

export default function ProductsHealthMenu() {
  const classes = useStyles();

  const selectedLanguage: string = useSelector(
    (state: ApplicationState) => state.userSettingsReducer.selectedLanguage,
  );

  const [currentLocale, setCurrentLocale] = React.useState<LocaleInterface>(
    locales[0],
  );

  const [lastRefresh, setLastRefresh] = React.useState<Date>(new Date());

  const isLogin: boolean = useSelector(
    (state: ApplicationState) => state.userSessionReducer.isLoggedIn,
  );
  const dispatch: Dispatch<any> = useDispatch();

  useEffect(() => {
    if (isLogin) {
      getAssetStoreList(dispatch);
      getDivisionList(dispatch);
      getLaneNumbers(dispatch);
      getNodeTypeList(dispatch);
      getNodeGroups(dispatch);
      getNodeVersionPropertyValues(dispatch);
    }
    return () => {};
  }, [isLogin]);

  const setLastRefreshQuery = (lastRefreshDate: Date) => {
    setLastRefresh(lastRefreshDate);
  };

  useEffect(() => {
    if (selectedLanguage == 'English') {
      setCurrentLocale(locales[0]);
    } else if (selectedLanguage == 'French') {
      setCurrentLocale(locales[1]);
    }
  }, [selectedLanguage]);

  return (
    <>
      <Helmet>
        <title>
          {GetString('PAGE_TITLE_PRODUCTS_HEALTH')} | {APP_TITLE}
        </title>
      </Helmet>
      <Header
        open={true}
        pageDisplayed={GetString('PAGE_TITLE_PRODUCTS_HEALTH')}
      />
      <Paper className={classes.paperGrid}>
        <ProductsHealthGrid setLastRefreshQuery={setLastRefreshQuery} />
        <Typography color="textSecondary" className={classes.dateTime}>
          {GetString('LAST_REFRESH_DATETIME')}
          {formatDateToLocaleDateString(currentLocale.language, lastRefresh)}
        </Typography>
      </Paper>
    </>
  );
}
